<template>
  <v-sheet class="border-opacity-25 border-thin rounded-lg overflow-y-auto">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          You about to send an email to {{ castCrew.first_name }} {{ castCrew.last_name }} at
          {{ castCrew.email_address }}. They will be able to sign the release.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <FullSecondaryButton @click="emit('close')">Cancel</FullSecondaryButton>
        </v-col>
        <v-col cols="12" md="6">
          <FullWidthButton @click="sendEmail">Send Email</FullWidthButton>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script setup lang="ts">
import { ISubmissionCastCrewDTO, SubmissionCastCrewDTO } from '@/dtos';
import { useReleaseStore } from '@/stores';
import { ref } from 'vue';
interface Props {
  castCrew: ISubmissionCastCrewDTO;
  submissionId: string;
}
const props = defineProps<Props>();
const castCrew = ref<ISubmissionCastCrewDTO>(new SubmissionCastCrewDTO(props.castCrew));
const emit = defineEmits(['email-sent', 'close']);
const releaseStore = useReleaseStore();

const sendEmail = async () => {
  await releaseStore.sendEmail.mutateAsync({
    castCrew: castCrew.value,
    submissionId: props.submissionId,
  });
  emit('close');
};
</script>
